/**
 * @generated SignedSource<<402d513e280c43eec92beaef59716e5a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ClientProgramWeek_completion$data = {
  readonly rate: number;
  readonly " $fragmentType": "ClientProgramWeek_completion";
};
export type ClientProgramWeek_completion$key = {
  readonly " $data"?: ClientProgramWeek_completion$data;
  readonly " $fragmentSpreads": FragmentRefs<"ClientProgramWeek_completion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ClientProgramWeek_completion",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rate",
      "storageKey": null
    }
  ],
  "type": "Completion",
  "abstractKey": null
};

(node as any).hash = "dbdd3dd0ea50ce24f1dae5416e78afd5";

export default node;
